import { PublicOccurrence } from '@cademy-package/sdk-component-types';
import { Address } from '@shared/types';

export const trimCommas = (str: string = '') => {
    if (!str) return '';
    return str.replace(/,\s*$/, '');
};

export const isSameString = (string1?: string, string2?: string) => {
    const normalisedString1 = (string1 || '').trim().toUpperCase();
    const normalisedString2 = (string2 || '').trim().toUpperCase();
    return normalisedString1 === normalisedString2;
};

export const isSameAddress = (address1: Address, address2: Address) => {
    const isSameStreet = isSameString(address1.street, address2.street);
    const isSameCity = isSameString(address1.city, address2.city);
    const isSamePostcode =
        isSameString(address1.postcode, address2.postcode) ||
        !address1.postcode ||
        !address2.postcode;
    const isSameCountry = isSameString(address1.country, address2.country);
    if (
        isSameStreet === true &&
        isSameCity === true &&
        isSamePostcode === true &&
        isSameCountry === false
    ) {
        return true;
    }
    return (
        isSameStreet === true &&
        isSameCity === true &&
        isSamePostcode === true &&
        isSameCountry === true
    );
};

export const getUniqueOccurenceAddresses = (
    courseAddress: Address,
    occurrences: Array<PublicOccurrence>
) => {
    const possibleAddresses = occurrences
        .filter((occurrence) => {
            return occurrence.delivery !== 'online';
        })
        .map((occurrence) => {
            if (occurrence?.address?.city) {
                return occurrence.address;
            }
            return courseAddress;
        })
        .filter((address) => {
            if (address !== null && address !== undefined) {
                return Object.keys(address).length !== 0;
            }
            return false;
        })
        .map((address) => {
            return {
                ...address,
                city: trimCommas(address.city),
                street: trimCommas(address.street),
            };
        });

    const unique = possibleAddresses.filter((address, index, possibleAddresses) => {
        const duplicateIndex = possibleAddresses.findIndex((findAddress) =>
            isSameAddress(address, findAddress)
        );
        return duplicateIndex === index;
    });

    return unique;
};
